module.exports = __webpack_public_path__ + "img/Path.1b166e69.svg";